var closeTooltip;
export function registerTooltipCloseFn(closeFn) {
  if (closeTooltip === closeFn) {
    return;
  }
  if (closeTooltip) {
    closeTooltip();
  }
  closeTooltip = closeFn;
}